<template>
  <div class="about">
    <a href="https://github.com/cseitz/intro-to-db-project1">Source Code</a>
  </div>
</template>
